var indentStyle = {"indentZero":"NNQiU","indentOne":"YOopS","indentTwo":"zWEEp","indentThree":"hIF6Q","indentFour":"Zc51O","indentFive":"tIFHC","indentSix":"_0d5zI"};

export { indentStyle as i };
//# sourceMappingURL=indentation-f72456fb.js.map
